import { currentSemester } from "@cs124/person";
import moment from "moment-timezone";
import { Array, Boolean, Literal, Number, Partial, Record, String, Undefined } from "runtypes";
import { GITHUBGRADER_JOB_COLLECTION } from "./collections";
export const Deadline = Record({
  used: String,
  default: String,
  gracePeriod: String,
  extended: Boolean,
  made: Boolean
});
export const OutputLine = Record({
  task: String,
  command: String,
  console: String,
  line: String,
  timestamp: String
});
export const Job = Record({
  email: String,
  commit: Record({
    message: String,
    timestamp: String,
    url: String,
    id: String
  }),
  repository: Record({
    name: String
  }),
  push: Record({
    receivedTime: String
  })
}).And(
  Partial({
    timestamps: Record({
      created: String
    }).And(
      Partial({
        graded: String,
        queued: String,
        scored: String
      })
    ),
    status: Record({
      ignored: Boolean,
      badEmail: Boolean,
      queued: Boolean
    }).And(
      Partial({
        graded: Boolean
      })
    ),
    grading: Record({
      assignment: Record({
        checkpoint: Number
      }),
      failed: Boolean,
      timedOut: Boolean,
      output: Array(OutputLine),
      created: String
    }).And(
      Partial({
        started: String,
        ended: String
      })
    ),
    score: Record({
      best: Boolean,
      adjustedScore: Number,
      outOf: Number,
      components: Array(
        Record({
          score: Number,
          outOf: Number,
          type: String,
          name: String,
          message: String
        })
      ),
      deadlines: Record({
        semester: Deadline,
        assignment: Deadline
      }).And(
        Partial({
          early: Deadline
        })
      )
    })
  })
);
export const Scores = Record({
  available: Array(Number),
  jobs: Array(Job)
}).And(
  Partial({
    repository: String
  })
);
export const Collaboration = Record({
  type: Literal("collaboration"),
  semester: String,
  number: String,
  language: String,
  from: String,
  joined: Boolean
}).And(
  Partial({
    to: String,
    ai: Boolean
  })
);
export const MP_RELEASES = {
  Spring2025: {
    0: "2025-03-31",
    1: "2025-04-06",
    2: "2025-04-13",
    3: "2025-04-23"
  },
  Summer2025: {
    0: "2025-07-16",
    1: "2025-07-20",
    2: "2025-07-23",
    3: "2025-07-30"
  }
};
export function studentCanSeeMP(MP, semester, now = /* @__PURE__ */ new Date()) {
  if (!MP_RELEASES[semester]) {
    return semester !== currentSemester.shorthand;
  }
  return moment.tz(MP_RELEASES[semester][MP], "YYYY-MM-DD", "America/Chicago").isBefore(moment(now));
}
export function allMPs(semester) {
  if (!MP_RELEASES[semester]) {
    if (["Fall2023", "Spring2024", "Fall2024", "Spring2025", "Summer2025"].includes(semester)) {
      return [0, 1, 2, 3];
    } else {
      return [0, 1, 2];
    }
  }
  return Object.keys(MP_RELEASES[semester]).map((c) => parseInt(c)).sort((a, b) => a - b);
}
export function availableMPs(semester, now = /* @__PURE__ */ new Date()) {
  return allMPs(semester).filter((n) => studentCanSeeMP(n, semester, now));
}
export async function bestScoresFor(options) {
  const { db, email, semester } = options;
  const githubGraderJobCollection = db.collection(GITHUBGRADER_JOB_COLLECTION);
  return Array(Job).check(
    await githubGraderJobCollection.find({
      email,
      "push.receivedSemester": semester,
      "score.best": true,
      ignored: { $ne: true }
    }).sort({ "grading.assignment.checkpoint": 1 }).project({ _id: 0 }).toArray()
  );
}
export async function repositoryFor(options) {
  const { db, email, semester } = options;
  const githubGraderJobCollection = db.collection(GITHUBGRADER_JOB_COLLECTION);
  return String.Or(Undefined).check(
    (await githubGraderJobCollection.find({
      "push.receivedSemester": semester,
      email,
      ignored: { $ne: true }
    }).project({ repository: 1, timestamps: 1 }).sort({ "timestamps.created": -1 }).limit(1).toArray())[0]?.repository?.name ?? void 0
  );
}
//# sourceMappingURL=githubgrader.js.map
